<template>
  <v-menu
    class="ui-menu kyano-menu"
    width="240"
    max-height="260"
    v-model="menuOpen"
    transition="slide-y-transition"
    persistent
    contained
  >
    <template #default>
      <div class="card pa-1">
        <!-- ─── FIELDS ───────────────────────────── -->
        <v-list density="compact">
          <template v-if="items.length">
            <v-list-item
              v-for="(item, idx) in items"
              :key="`field-${item.id}`"
              :class="{ 'is-selected': idx === selectedIndex }"
              class="mb-1"
              @click="selectField(idx)"
            >
              <template #prepend>
                <div
                  class="icon-custom-field d-flex"
                  v-html="icons('field-' + item.field_type)"
                />
              </template>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>

          <ui-list-item
            v-else
            :title="$t('no_results')"
            class="px-2 py-1 text-subtitle-2"
          />
        </v-list>

        <!-- scheiding -->
        <v-divider class="my-2" />

        <!-- ─── ACTIEVE GEBRUIKER ────────────────── -->
        <v-list density="compact">
          <v-subheader class="py-1 px-3 text-caption">
            {{ $t("active_user") }}
          </v-subheader>

          <template v-if="activeUserFields.length">
            <v-list-item
              v-for="(row, id) in activeUserFields"
              :key="row.key"
              class="mb-1"
              @click="selectUserField(id)"
            >
              <template #prepend>
                <i class="fal fa-user-circle mr-2" />
              </template>

              <v-list-item-title>{{ row.label }}</v-list-item-title>
              <v-list-item-subtitle class="text-truncate">
                {{ row.value !== null && row.value !== "" ? row.value : "—" }}
              </v-list-item-subtitle>
            </v-list-item>
          </template>

          <ui-list-item
            v-else
            :title="$t('no_results')"
            class="px-2 py-1 text-subtitle-2"
          />
        </v-list>
      </div>
    </template>
  </v-menu>
</template>

<script>
  import { icons } from "@/util/Icons";
  import { useAppStore } from "@/stores/appStore";

  export default {
    name: "FieldAndActiveUserDropdown",

    props: {
      items: { type: Array, default: () => [] },
      command: { type: Function, required: true },
    },

    data() {
      return {
        selectedIndex: 0,
        menuOpen: true,
      };
    },

    computed: {
      appStore() {
        return useAppStore();
      },

      /* de volledige user-record uit de store */
      activeUser() {
        return this.appStore.active.user || {};
      },

      /* fields-definitie voor collectie 2 (users-tabel) */
      userFieldDefs() {
        const group = this.appStore.all_fields.find((g) => g.collection.id === 2);
        return group ? group.fields : [];
      },

      /* lijst van {key,label,value} voor de actieve user */
      activeUserFields() {
        return this.userFieldDefs.map((def) => ({
          key: def.column_name,
          label: def.title || def.label || def.column_name,
          value: this.activeUser[def.column_name] ?? null,
        }));
      },
    },

    watch: {
      items() {
        this.selectedIndex = 0;
      },
    },

    created() {
      /* als de actieve user nog niet is gezet proberen we er één te kiezen */
      if (!this.appStore.active.user?.id && this.appStore.users.length) {
        this.appStore.setActiveUser(this.appStore.users[0]);
      }
    },

    methods: {
      icons,

      /* ── field uit je items-prop ───────────── */
      selectField(idx) {
        const item = this.items[idx];
        if (item) {
          this.command({ ...item });
        }
        this.menuOpen = false;
      },

      selectUserField(idx) {
        const field = this.activeUserFields[idx];
        if (field) {
          this.command({
            id: field.key,
            label: field.key,
            title: field.key,
            value: field.key,
            field_type: "user",
            "data-user": "true",
          });
        }
        this.menuOpen = false;
      },

      /* optionele pijltjes-navigatie alleen voor items-lijst */
      onKeyDown({ event }) {
        const len = this.items.length;
        if (!len) return false;

        switch (event.key) {
          case "ArrowUp":
            this.selectedIndex = (this.selectedIndex + len - 1) % len;
            return true;
          case "ArrowDown":
            this.selectedIndex = (this.selectedIndex + 1) % len;
            return true;
          case "Enter":
            this.selectField(this.selectedIndex);
            return true;
          default:
            return false;
        }
      },
    },
  };
</script>

<style scoped>
  .icon-custom-field {
    width: 15px;
    height: 15px;
  }

  .icon-custom-field svg {
    width: 15px;
    height: 15px;
    opacity: 0.8;
  }

  .is-selected {
    background: var(--tertiary-50);
    color: var(--tertiary);
  }
</style>
